import { render } from "./VideoOnDemandComponent.vue?vue&type=template&id=529ed7ac&scoped=true&ts=true"
import script from "./VideoOnDemandComponent.vue?vue&type=script&lang=ts"
export * from "./VideoOnDemandComponent.vue?vue&type=script&lang=ts"

import "./VideoOnDemandComponent.vue?vue&type=style&index=0&id=529ed7ac&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-529ed7ac"]])

export default __exports__